export default __webpack_public_path__ + "static/media/opensans-regular-webfont.175ff3ff.woff";